import {Pipe, PipeTransform} from '@angular/core';
import {IUsuarioAll} from '../modelos/IUsuario';

@Pipe({
  name: 'searchCmbBox'
})
export class SearchCmbBoxPipe implements PipeTransform {

  transform(value: IUsuarioAll[], query: string): unknown {
    if (query === '' || !query) return value;
    return value.filter(val => `${val.login} ${val.login2} ${val.nombre}`.toLowerCase().indexOf(query) != -1)
  }

}
